import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["actions", "handleTooltip", "responsiveSize", "onDropdownOpenChange", "connectDragSource"];
import { memoize } from 'underscore';
import { TrellisPinnedToolbar as PinnedToolbar } from 'layout-dnd-components/DndToolbar/PinnedToolbar';
import { buildStyleRowAction, buildDuplicateRowAction, buildDeleteRowAction } from './BaseResponsiveRowToolbar';
import { hashFunctionForNArgs } from './helpers';
import { buildStyleColumnAction, buildDuplicateColumnAction, buildDeleteColumnAction } from './BaseResponsiveColumnToolbar';
import { useSelector } from 'react-redux';
import { getIsTrellisTheme } from '../../redux/selectors/layoutSectionDndSelectors';
import { SpacerIcon } from 'foundations-assets/icons/components/SpacerIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export const buildActionsForEmptyColumn = memoize((columnName, layoutSectionId, dispatch, bus) => {
  return [buildStyleColumnAction(columnName, layoutSectionId, dispatch, bus), buildDuplicateColumnAction(columnName, layoutSectionId, dispatch, bus), buildDeleteColumnAction(columnName, layoutSectionId, dispatch, bus)];
}, hashFunctionForNArgs(2));
export const buildActionsForEmptyRow = memoize((rowName, layoutSectionId, dispatch, bus) => {
  return [buildStyleRowAction(rowName, layoutSectionId, dispatch, bus), buildDuplicateRowAction(rowName, layoutSectionId, dispatch, bus), buildDeleteRowAction(rowName, layoutSectionId, dispatch, bus)];
}, hashFunctionForNArgs(2));
export const BaseResponsiveEmptyContainerToolbar = _ref => {
  let {
      actions,
      handleTooltip,
      responsiveSize,
      onDropdownOpenChange,
      connectDragSource
    } = _ref,
    toolbarProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const isTrellisTheme = useSelector(getIsTrellisTheme);
  return /*#__PURE__*/_jsx(PinnedToolbar, Object.assign({
    variant: "primary",
    position: "absolute",
    zIndex: 5001,
    "data-test-id": "hs-ls-responsive-empty-toolbar",
    active: true,
    pinLocation: "top right",
    icon: SpacerIcon,
    actions: actions,
    onDropdownOpenChange: onDropdownOpenChange,
    responsiveSize: responsiveSize,
    handleTooltip: handleTooltip,
    handleButtonRef: handleButtonElement => {
      if (handleButtonElement && connectDragSource) {
        connectDragSource(handleButtonElement);
      }
    },
    handleButtonStyles: {
      cursor: 'move',
      borderWidth: '100'
    },
    draggable: true,
    isTrellisTheme: isTrellisTheme
  }, toolbarProps));
};